//@ts-nocheck
import {Column} from 'react-table'
import {EvaluationReport} from '../../core/_models'
import {EvaluationReportIDCell} from './EvaluationReportIDCell'
import {EvaluationReportStatus} from './EvaluationReportStatus'
import {EvaluationReportTypeCell} from './EvaluationReportTypeCell'
import {EvaluationReportYearCell} from './EvaluationReportYearCell'
import {EvaluationReportNumberCell} from './EvaluationReportNumberCell'

import {EvaluationReportCustomHeader} from './EvaluationReportCustomHeader'
import {EvaluationReportActionsCell} from './EvaluationReportActionsCell'
import {EvaluationReportDownloadCell} from './EvaluationReportDownloadCell'

const EvaluationReportColumns: ReadonlyArray<Column<EvaluationReport>> = [
  {
    Header: (props) => (
      <EvaluationReportCustomHeader
        tableProps={props}
        title='COMMON.INPUT_ID'
        className='text-center fs-8 min-w-125px'
      />
    ),
    id: 'id',
    Cell: ({...props}) => <EvaluationReportIDCell evaluationReport={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <EvaluationReportCustomHeader
        tableProps={props}
        title='COMMON.STATUS'
        className='text-center fs-8 min-w-125px'
      />
    ),
    id: 'status',
    Cell: ({...props}) => <EvaluationReportStatus evaluationReport={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <EvaluationReportCustomHeader
        tableProps={props}
        title='COMMON.TYPE'
        className='text-center fs-8 min-w-125px'
      />
    ),
    id: 'type',
    Cell: ({...props}) => (
      <EvaluationReportTypeCell evaluationReport={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <EvaluationReportCustomHeader
        tableProps={props}
        title='COMMON.YEAR'
        className='text-center fs-8 min-w-125px'
      />
    ),
    id: 'reference_year',
    Cell: ({...props}) => (
      <EvaluationReportYearCell evaluationReport={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <EvaluationReportCustomHeader
        tableProps={props}
        title='COMMON.NUMBER'
        className='text-center fs-8 min-w-125px'
      />
    ),
    id: 'evaluation_report_number',
    Cell: ({...props}) => (
      <EvaluationReportNumberCell evaluationReport={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <EvaluationReportCustomHeader
        tableProps={props}
        title='COMMON.DOWNLOAD'
        className='text-center fs-8 min-w-100px '
      />
    ),
    id: 'download',
    Cell: ({...props}) => <EvaluationReportDownloadCell data={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <EvaluationReportCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='text-center fs-8 min-w-100px '
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <EvaluationReportActionsCell data={props.data[props.row.index]} />,
  },
]

export {EvaluationReportColumns}
